module.exports = __webpack_public_path__ + "static/img/19.994aea70.png";